import { transformResourceData, transformCouponData, transformSupplyData, transformTabbarData } from './transformData';

/**
 * 构建 initialState 的公共逻辑
 * 用于 entry-client 和 entry-server 中的数据转换
 * 
 * @param prefetchData - 预取的数据
 * @returns 转换后的 initialState 对象，如果没有数据则返回 undefined
 */
export function buildCommonInitialState(prefetchData: any) {
  if (!prefetchData) return undefined;
  
  return {
    resourceData: prefetchData.resource 
      ? transformResourceData(prefetchData.resource) 
      : undefined,
    couponData: prefetchData.couponData 
      ? transformCouponData(
          prefetchData.couponData,
          prefetchData.isNotLoggedIn // 传递401未登录状态
        )
      : undefined,
    supplyData: prefetchData.supplyData 
      ? transformSupplyData(prefetchData.supplyData) 
      : undefined,
    tabbarData: prefetchData.searchRule 
      ? transformTabbarData(prefetchData.searchRule) 
      : undefined,
    isOpenCity: prefetchData.isOpenCity,
  };
}
